import React from 'react';
import { Sparkles, Users, Cpu, ShieldCheck, Zap } from 'lucide-react';

interface HeroSectionProps {
  totalJobs: number;
}

export const HeroSection: React.FC<HeroSectionProps> = ({ totalJobs }) => {
  return (
    <section className="hero-section">
      <div className="container">
        <div className="hero-pill">
          <Sparkles size={14} />
          SansCraft Network Team Openings
        </div>

        <h1 className="hero-title">
          Build the Next Generation of <br />
          <span className="gradient-text">Minecraft & Edge Server Architecture</span>
        </h1>

        <p className="hero-subtitle">
          Join our passionate team of developers, sysadmins, game designers, and moderators shaping high-throughput Minecraft networks and cloud edge experiences.
        </p>

        {/* Live Network Stats */}
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-number">{totalJobs}</div>
            <div className="stat-label">Active Job Openings</div>
          </div>
          <div className="stat-card">
            <div className="stat-number" style={{ color: 'var(--accent-purple)' }}>&lt; 10ms</div>
            <div className="stat-label">Network Sync Latency</div>
          </div>
          <div className="stat-card">
            <div className="stat-number" style={{ color: 'var(--accent-emerald)' }}>100%</div>
            <div className="stat-label">Remote / Flexible Roles</div>
          </div>
          <div className="stat-card">
            <div className="stat-number" style={{ color: 'var(--accent-amber)' }}>24/7</div>
            <div className="stat-label">Active Player Community</div>
          </div>
        </div>
      </div>
    </section>
  );
};
